import { render, staticRenderFns } from "./TileGridWidget.vue?vue&type=template&id=566022b5&scoped=true"
import script from "./TileGridWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileGridWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TileGridWidget.vue?vue&type=style&index=0&id=566022b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566022b5",
  null
  
)

export default component.exports